import moment from 'moment'
import {mapActions,mapState} from 'vuex'
import CloseSessionAlertModal from '@/components/modals/CloseSessionAlertModal'
import SessionClosedAlertModal from '@/components/modals/SessionClosedAlertModal'
import {TIME_LOCAL_PAGE_TIMER, TIME_INITIAL_PAGE_TIMER, TIME_ZERO} from '../constants'

// Importar jQuery global
const $ = window.$ || require('jquery');

export default {
    data() {
        return {
            interval : null,
            timerStarted : false,
            modalVisible : false,
            activityListenersPaused : false,
            modalShown : false, // Flag para prevenir múltiples ejecuciones
            sessionClosed : false, // Flag para indicar que la sesión ya se cerró
            localTimer : TIME_LOCAL_PAGE_TIMER, // Timer local para evitar conflictos con el store
            useLocalTimer : true // Flag para usar timer local en lugar del store
        }
    },
    components : {
        CloseSessionAlertModal,
        SessionClosedAlertModal
    },
    computed : {
        ...mapState(['localPageTimer']),
        currentTimer() {
            return this.useLocalTimer ? this.localTimer : this.localPageTimer;
        }
    },
    methods: {
        ...mapActions(['setLocalPageTimer']),
        async updateLocalPageTimer(){
            
            if (this.timerStarted) {
                return;
            }
            
            this.timerStarted = true;
            this.localTimer = TIME_INITIAL_PAGE_TIMER; // Iniciar desde la constante
            
            this.interval = setInterval(()=>{
                const newTime = moment(this.localTimer,'mm:ss').subtract(1,"second").format('mm:ss');
                this.localTimer = newTime;
                
                // Verificar si necesitamos mostrar el modal (cuando falten 30 segundos para completar 1 minuto)
                if (newTime === TIME_LOCAL_PAGE_TIMER && !this.modalVisible && !this.modalShown && !this.sessionClosed) {
                    this.showWarningModal();
                }
                
                if (newTime === TIME_ZERO) {
                    
                    // Emitir evento para forzar cierre de modales
                    this.$root.$emit('timer-reached-zero');
                    
                    // Limpiar el intervalo para detener el timer
                    if (this.interval) {
                        clearInterval(this.interval);
                        this.interval = null;
                    }
                    
                    // Cerrar el modal de advertencia si está abierto - método más agresivo
                    if (this.modalVisible) {
                        
                        // Método 1: Usar jQuery modal (verificar que jQuery esté disponible)
                        if (window.$ && typeof window.$.fn.modal === 'function') {
                            window.$('#close-session-alert-modal').modal('hide');
                        }
                        
                        // Método 2: Usar el helper si existe
                        const helper = document.getElementById('helperSessionModal');
                        if (helper) {
                            helper.click();
                        }
                        
                        // Método 3: Forzar cierre removiendo backdrop y clases usando vanilla JS
                        setTimeout(() => {
                            const backdrops = document.querySelectorAll('.modal-backdrop');
                            backdrops.forEach(backdrop => backdrop.remove());
                            document.body.classList.remove('modal-open');
                        }, 50);
                        
                        this.modalVisible = false;
                        this.modalShown = false;
                        this.activityListenersPaused = false;
                    }
                    
                    // Esperar un momento para que se cierre el modal y luego mostrar el modal de sesión cerrada
                    setTimeout(() => {
                        this.showSessionClosedModal();
                    }, 500);
                }
            },1000)
        },
        resetTimer(){
            // Limpiar el intervalo actual
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
            
            // Resetear estados
            this.timerStarted = false;
            this.modalVisible = false;
            this.activityListenersPaused = false; // Reanudar event listeners
            this.modalShown = false; // Resetear flag de modal
            this.sessionClosed = false; // Resetear flag de sesión cerrada
            
            // Iniciar nuevo timer
            this.updateLocalPageTimer();
        },
        
        // Método específico para reiniciar el timer cuando el usuario hace clic en "Continuar"
        resetTimerFromModal(){
            
            // Limpiar el intervalo actual
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
            
            // Resetear estados
            this.timerStarted = false;
            this.modalVisible = false;
            this.activityListenersPaused = false; // Reanudar event listeners
            this.modalShown = false; // Resetear flag de modal
            this.sessionClosed = false; // Resetear flag de sesión cerrada
            
            // Iniciar nuevo timer
            this.updateLocalPageTimer();
        },
        
        // Método para manejar cuando el usuario cierra el modal sin continuar
        handleModalClose(){
            this.modalVisible = false;
            this.activityListenersPaused = false; // Reanudar event listeners
            // No reiniciar el timer, dejar que continúe contando
        },
        
        // Método para limpiar completamente el timer (usado cuando se vuelve al inicio)
        clearTimer(){
            
            // Limpiar el intervalo actual
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
            
            // Resetear todos los estados
            this.timerStarted = false;
            this.modalVisible = false;
            this.activityListenersPaused = false;
            this.modalShown = false; // Resetear flag de modal
            this.sessionClosed = false; // Resetear flag de sesión cerrada
            
            // Resetear el timer local
            this.localTimer = TIME_INITIAL_PAGE_TIMER; // Resetear usando la constante
            
            // Cerrar cualquier modal que esté abierto usando vanilla JS
            const modals = document.querySelectorAll('.modal');
            modals.forEach(modal => {
                if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(modal).modal('hide');
                }
            });
            
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
            document.body.classList.remove('modal-open');
            
        },
        
        // Método para mostrar el modal de advertencia
        showWarningModal(){
            this.modalVisible = true;
            this.modalShown = true;
            this.activityListenersPaused = true;
            
            // Verificar que el helper existe antes de hacer clic
            const helper = window.$('#helperSessionModal')[0];
            if (helper) {
                helper.click();
            } else {
                console.error('❌ Helper helperSessionModal no encontrado');
            }
        },
        
        // Método para mostrar el modal de sesión cerrada
        showSessionClosedModal(){
            
            // Marcar la sesión como cerrada para evitar que se muestre el modal de advertencia nuevamente
            this.sessionClosed = true;
            
            // Asegurarse de que no hay otros modales abiertos usando vanilla JS
            const modals = document.querySelectorAll('.modal');
            modals.forEach(modal => {
                if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(modal).modal('hide');
                }
            });
            
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
            document.body.classList.remove('modal-open');
            
            // Resetear estados
            this.modalVisible = false;
            this.modalShown = false;
            this.activityListenersPaused = false;
            
            // Verificar que el helper existe antes de hacer clic
            const helper = document.getElementById('helperSessionClosedModal');
            if (helper) {
                helper.click();
            } else {
                console.error('❌ Helper helperSessionClosedModal no encontrado');
            }
        },
        
        // Método para obtener el timer actual (para usar en modales)
        getCurrentTimer(){
            const timer = this.useLocalTimer ? this.localTimer : this.localPageTimer;
            return timer;
        }
    },
    beforeDestroy(){
        clearInterval(this.interval);
        this.$root.$off('reset-inactivity-modal');
        this.$root.$off('clear-inactivity-timer');
        this.$root.$off('get-current-timer');
    },
    mounted(){
        this.updateLocalPageTimer();
        
        // Escuchar el evento de reinicio del modal
        this.$root.$on('reset-inactivity-modal', () => {
            this.modalVisible = false;
            this.resetTimerFromModal();
        });
        
        // Escuchar el evento de limpieza completa (cuando se vuelve al inicio)
        this.$root.$on('clear-inactivity-timer', () => {
            this.clearTimer();
        });
        
        // Emitir el timer actual para que los modales lo usen
        this.$root.$on('get-current-timer', (callback) => {
            if (callback && typeof callback === 'function') {
                callback(this.getCurrentTimer());
            }
        });
        
        // Emitir evento cuando el timer llega a cero
        this.$root.$on('timer-reached-zero', () => {
            // Forzar cierre de cualquier modal abierto usando vanilla JS
            const modals = document.querySelectorAll('.modal');
            modals.forEach(modal => {
                if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(modal).modal('hide');
                }
            });
            
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
            document.body.classList.remove('modal-open');
        });
        
        // Agregar event listeners para detectar actividad del usuario
        const resetTimerOnActivity = () => {
            // Solo reiniciar el timer si no hay modal visible, el timer está activo y los listeners no están pausados
            if (this.timerStarted && !this.modalVisible && !this.activityListenersPaused) {
                this.resetTimer();
            }
        };
        
        // Eventos que indican actividad del usuario
        document.addEventListener('mousemove', resetTimerOnActivity);
        document.addEventListener('keydown', resetTimerOnActivity);
        document.addEventListener('click', resetTimerOnActivity);
        document.addEventListener('scroll', resetTimerOnActivity);
        
        // Limpiar event listeners cuando el componente se destruye
        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('mousemove', resetTimerOnActivity);
            document.removeEventListener('keydown', resetTimerOnActivity);
            document.removeEventListener('click', resetTimerOnActivity);
            document.removeEventListener('scroll', resetTimerOnActivity);
            
            // Limpiar event listeners del modal
            $(document).off('keydown');
            $(document).off('click', '.modal-backdrop');
            $(document).off('hidden.bs.modal', '#close-session-alert-modal');
        });
        
        // Escuchar cuando se cierra el modal de advertencia
        $(document).on('hidden.bs.modal', '#close-session-alert-modal', () => {
            if (this.modalVisible) {
                this.handleModalClose();
            }
        });
        
        // Prevenir cierre del modal con ESC o clic fuera del modal
        $(document).on('keydown', (e) => {
            if (this.modalVisible && e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });
        
        $(document).on('click', '.modal-backdrop', (e) => {
            if (this.modalVisible) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });
    },

};
  